(function () {
  var d = document, root = d.documentElement;
  if (window.Shopify && Shopify.designMode) { root.classList.remove('fl-js'); return; }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) { root.classList.remove('fl-js'); window.__flReady = true; return; }

  var GRUPOS = [
    ['.fl-head', 'up'],
    ['.fl-cat', 'card'],
    ['.fl-card', 'card'],
    ['.fl-more', 'up'],
    ['.fl-man > *', 'up'],
    ['.fl-trust__it', 'card'],
    ['.fl-sets__img', 'left'],
    ['.fl-sets__txt > *', 'right'],
    ['.fl-step', 'card'],
    ['.fl-faq details', 'up'],
    ['.fl-foot__grid > div', 'up']
  ];

  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('fl-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  function preparar(ambito) {
    GRUPOS.forEach(function (g) {
      var els = (ambito || d).querySelectorAll(g[0]);
      var contador = new Map();
      els.forEach(function (el, i) {
        if (el.dataset.flRv) return;
        el.dataset.flRv = '1';
        var padre = el.parentElement;
        var n = contador.get(padre) || 0; contador.set(padre, n + 1);
        el.classList.add('fl-rv', 'fl-rv--' + g[1]);
        el.style.setProperty('--d', Math.min(n * 0.12, 0.72) + 's');
        el.style.setProperty('--r', (n % 2 ? 3 : -3) + 'deg');
        io.observe(el);
      });
    });
  }

  function iniciar() { preparar(d); window.__flReady = true; }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  d.addEventListener('shopify:section:load', function (e) { preparar(e.target); });
})();

(function () {
  var CHECKOUT = 'https://finaluz-checkout.finaluz.workers.dev/';
  var d = document;
  function habil(n) { var f = new Date(), c = 0; while (c < n) { f.setDate(f.getDate() + 1); if (f.getDay() % 6) c++; } return f; }
  function fmt(f) { return f.toLocaleDateString('es-CO', { weekday: 'long', day: 'numeric', month: 'long' }); }
  function fechas() {
    var a = d.querySelector('[data-fl-d1]'), b = d.querySelector('[data-fl-d2]');
    if (a && b) { a.textContent = fmt(habil(3)); b.textContent = fmt(habil(5)); }
  }
  function ir(items) { location.href = CHECKOUT + '?back=' + encodeURIComponent(location.origin) + '&items=' + items; }
  d.addEventListener('click', function (e) {
    var ya = e.target.closest('[data-fl-buy]');
    if (ya) {
      e.preventDefault(); e.stopImmediatePropagation();
      var form = d.querySelector('form[action*="/cart/add"]');
      var id = form && form.querySelector('[name="id"]');
      var q = form && form.querySelector('[name="quantity"]');
      if (!id) return;
      var n = +(ya.getAttribute('data-fl-q') || (q ? q.value : 1)) || 1;
      /* Si ya hay piezas en el carrito (p. ej. volvio desde el checkout a elegir otra), se suman todas. */
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        if (!c.items.length) return ir(id.value + ':' + n);
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +id.value, quantity: n }] }) })
          .then(function () { return fetch('/cart.js'); }).then(function (r) { return r.json(); })
          .then(function (c2) { ir(c2.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',')); });
      }).catch(function () { ir(id.value + ':' + n); });
      return;
    }
    var co = e.target.closest('a[href^="/checkout"], button[name="checkout"]');
    if (!co) return;
    e.preventDefault(); e.stopImmediatePropagation();
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      if (c.items.length) ir(c.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(','));
    });
  }, true);
  fechas(); d.addEventListener('shopify:section:load', fechas);
})();
